import React, { useMemo } from 'react';
import ReactSelect from 'react-select';
import { brandBase, mergeStyles } from '../utils/ReactSelectStyles';

const BrandSelect = React.forwardRef(({ styles, ...props }, ref) => {
  const finalStyles = useMemo(() => (styles ? mergeStyles(styles) : brandBase), [styles]);
  return <ReactSelect ref={ref} styles={finalStyles} {...props} />;
});

BrandSelect.displayName = 'BrandSelect';

export default BrandSelect;
export { components } from 'react-select';
